var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2899 46.3487C21.0042 46.3322 20.7423 46.5012 20.6358 46.7663C20.5292 47.0314 20.6047 47.3346 20.8207 47.5201C20.8563 47.6046 20.9214 47.6593 20.9865 47.714C24.1696 50.4313 31.0213 50.4296 34.2074 47.714C34.2755 47.656 34.3436 47.598 34.4101 47.5417C34.6395 47.3445 34.7179 47.0247 34.607 46.7431C34.496 46.4631 34.2192 46.2841 33.9173 46.2957C28.8962 46.2443 27.5969 38.9988 27.5969 38.9988C27.5969 38.9988 26.3006 46.2294 21.2899 46.3487Z",
    fill: "url(#paint0_linear_3871_969)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5997 39.8407C36.6488 39.8407 43.9846 32.5049 43.9846 23.4558C43.9846 14.4067 36.6488 7.07095 27.5997 7.07095C18.5506 7.07095 11.2148 14.4067 11.2148 23.4558C11.2148 32.5049 18.5506 39.8407 27.5997 39.8407Z",
    fill: "url(#paint1_radial_3871_969)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7614 13.8848C26.8871 13.6011 27.1692 13.4173 27.4804 13.4173C27.7915 13.4173 28.0737 13.6011 28.1994 13.8848C29.1135 15.9581 30.5806 19.2776 30.5806 19.2776C30.5806 19.2776 34.1887 19.6452 36.4442 19.8757C36.7537 19.908 37.0149 20.1192 37.1116 20.4142C37.2083 20.7092 37.1197 21.0349 36.8875 21.2412C35.1995 22.7535 32.4959 25.1734 32.4959 25.1734C32.4959 25.1734 33.2601 28.7202 33.7389 30.9353C33.805 31.24 33.6841 31.5528 33.4326 31.7366C33.1811 31.9188 32.8457 31.9365 32.5765 31.7801C30.6177 30.6403 27.4804 28.8169 27.4804 28.8169C27.4804 28.8169 24.3431 30.6403 22.3843 31.7801C22.115 31.9365 21.7797 31.9188 21.5282 31.7366C21.2767 31.5528 21.1558 31.24 21.2219 30.9353C21.7007 28.7202 22.4649 25.1734 22.4649 25.1734C22.4649 25.1734 19.7612 22.7535 18.0733 21.2412C17.8411 21.0349 17.7524 20.7092 17.8492 20.4142C17.9459 20.1192 18.2071 19.908 18.5166 19.8757C20.7721 19.6452 24.3801 19.2776 24.3801 19.2776C24.3801 19.2776 25.8472 15.9581 26.7614 13.8848Z",
    fill: "url(#paint2_linear_3871_969)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6383 44.2023C36.7489 44.1703 36.8209 44.0654 36.8123 43.9514C36.8018 43.8381 36.7138 43.7459 36.5992 43.7327C36.1762 43.6711 35.741 43.5323 35.2098 43.2679C34.4064 42.8692 33.6816 42.1102 33.2896 40.9029C32.8902 39.674 33.3959 38.528 33.3959 38.528C33.3959 38.528 30.6719 39.0742 30.3712 40.1654C30.09 41.1812 30.6599 42.414 31.7394 43.3553C32.6563 44.1547 34.2283 44.9509 36.6383 44.2023Z",
    fill: "url(#paint3_linear_3871_969)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.57 41.9256C40.6707 41.8707 40.7201 41.755 40.6876 41.6452C40.6551 41.5366 40.5494 41.4658 40.4362 41.475C40.0337 41.4968 39.6046 41.4524 39.0656 41.3153C38.2269 41.1023 37.3884 40.5341 36.7719 39.4762C36.144 38.3995 36.3862 37.2177 36.3862 37.2177C36.3862 37.2177 33.9305 38.2834 33.8704 39.3721C33.8132 40.3858 34.6026 41.4317 35.8126 42.0999C36.8354 42.6641 38.4678 43.0946 40.57 41.9256Z",
    fill: "url(#paint4_linear_3871_969)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.235 39.1717C44.3209 39.096 44.3433 38.9723 44.2877 38.8725C44.231 38.7742 44.1127 38.7276 44.0033 38.7619C43.6398 38.864 43.2358 38.9152 42.7145 38.9053C41.879 38.8914 40.9639 38.5439 40.1471 37.6874C39.3153 36.8159 39.2769 35.6527 39.2769 35.6527C39.2769 35.6527 37.2108 37.1978 37.3992 38.2332C37.5735 39.1976 38.55 40.0044 39.8364 40.3634C40.9182 40.6643 42.535 40.708 44.235 39.1717Z",
    fill: "url(#paint5_linear_3871_969)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7113 35.6063C46.7811 35.5173 46.7779 35.39 46.7025 35.3035C46.6271 35.217 46.5025 35.1953 46.4024 35.2511C46.0853 35.4124 45.7209 35.5371 45.2406 35.6304C44.447 35.7857 43.5101 35.6411 42.5625 34.9943C41.5976 34.3363 41.3242 33.2419 41.3242 33.2419C41.3242 33.2419 39.6837 35.1227 40.0731 36.0659C40.4346 36.9445 41.5232 37.512 42.8139 37.5925C43.8927 37.6603 45.4203 37.3769 46.7113 35.6063Z",
    fill: "url(#paint6_linear_3871_969)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8327 31.9446C48.8829 31.8412 48.8548 31.7178 48.7645 31.647C48.6738 31.5779 48.5463 31.5801 48.46 31.654C48.1946 31.8597 47.88 32.0424 47.4559 32.2194C46.7326 32.5219 45.8148 32.5664 44.789 32.1348C43.7447 31.6958 43.2718 30.7065 43.2718 30.7065C43.2718 30.7065 42.0806 32.8174 42.6341 33.6401C43.1485 34.4066 44.2928 34.7354 45.534 34.5609C46.5651 34.4165 47.9509 33.8548 48.8327 31.9446Z",
    fill: "url(#paint7_linear_3871_969)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.388 27.8405C49.4177 27.7303 49.3654 27.6141 49.2637 27.5623C49.162 27.5104 49.0376 27.5383 48.9664 27.6275C48.7589 27.8655 48.5029 28.0923 48.1497 28.3347C47.5255 28.7634 46.6667 28.9864 45.6119 28.7801C44.5381 28.5704 43.896 27.7274 43.896 27.7274C43.896 27.7274 43.186 29.9596 43.8714 30.629C44.5088 31.2531 45.6554 31.3387 46.7943 30.929C47.7339 30.5906 48.9246 29.7957 49.388 27.8405Z",
    fill: "url(#paint8_linear_3871_969)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7834 23.8211C49.7894 23.7071 49.7161 23.6048 49.6063 23.5753C49.4964 23.5458 49.3813 23.5961 49.3285 23.6977C49.182 23.9526 48.9898 24.211 48.7158 24.5003C48.2132 25.0306 47.4478 25.4141 46.4111 25.4319C45.3557 25.4503 44.5802 24.7841 44.5802 24.7841C44.5802 24.7841 44.3599 27.0338 45.1413 27.5275C45.8684 27.988 46.9674 27.8378 47.9595 27.2218C48.7727 26.7164 49.7294 25.7355 49.7834 23.8211Z",
    fill: "url(#paint9_linear_3871_969)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1588 20.0497C49.1446 19.9359 49.0531 19.8489 48.9401 19.8407C48.8275 19.8315 48.7231 19.9036 48.6913 20.0137C48.6028 20.2743 48.4748 20.5461 48.2791 20.8608C47.9087 21.4589 47.2624 21.9696 46.2901 22.188C45.3004 22.4106 44.4416 21.9329 44.4416 21.9329C44.4416 21.9329 44.6693 24.0984 45.5003 24.4122C46.2737 24.7053 47.279 24.3498 48.0936 23.5756C48.7571 22.9447 49.462 21.8438 49.1588 20.0497Z",
    fill: "url(#paint10_linear_3871_969)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7051 16.6184C47.6692 16.5119 47.5639 16.4453 47.4533 16.4591C47.3416 16.4726 47.2552 16.5625 47.245 16.6752C47.2081 16.9281 47.1417 17.1994 47.0243 17.5198C46.7927 18.1549 46.2856 18.7618 45.416 19.1578C44.531 19.5612 43.6331 19.2802 43.6331 19.2802C43.6331 19.2802 44.2661 21.2722 45.1062 21.4045C45.8883 21.5286 46.7622 20.9972 47.3762 20.1094C47.8731 19.3907 48.3172 18.2292 47.7051 16.6184Z",
    fill: "url(#paint11_linear_3871_969)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3617 44.2023C18.2511 44.1703 18.1791 44.0654 18.1877 43.9514C18.1982 43.8381 18.2862 43.7459 18.4008 43.7327C18.8238 43.6711 19.259 43.5323 19.7902 43.2679C20.5936 42.8692 21.3184 42.1102 21.7104 40.9029C22.1098 39.674 21.6041 38.528 21.6041 38.528C21.6041 38.528 24.3281 39.0742 24.6288 40.1654C24.91 41.1812 24.3401 42.414 23.2606 43.3553C22.3437 44.1547 20.7717 44.9509 18.3617 44.2023Z",
    fill: "url(#paint12_linear_3871_969)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.43 41.9256C14.3293 41.8707 14.2799 41.755 14.3124 41.6452C14.3449 41.5366 14.4506 41.4658 14.5638 41.475C14.9663 41.4968 15.3954 41.4524 15.9344 41.3153C16.7731 41.1023 17.6116 40.5341 18.2281 39.4762C18.856 38.3995 18.6138 37.2177 18.6138 37.2177C18.6138 37.2177 21.0695 38.2834 21.1296 39.3721C21.1868 40.3858 20.3974 41.4317 19.1874 42.0999C18.1646 42.6641 16.5322 43.0946 14.43 41.9256Z",
    fill: "url(#paint13_linear_3871_969)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.765 39.1717C10.6791 39.096 10.6567 38.9723 10.7123 38.8725C10.769 38.7742 10.8873 38.7276 10.9967 38.7619C11.3602 38.864 11.7642 38.9152 12.2855 38.9053C13.121 38.8914 14.0361 38.5439 14.8529 37.6874C15.6847 36.8159 15.7231 35.6527 15.7231 35.6527C15.7231 35.6527 17.7892 37.1978 17.6008 38.2332C17.4265 39.1976 16.45 40.0044 15.1636 40.3634C14.0818 40.6643 12.465 40.708 10.765 39.1717Z",
    fill: "url(#paint14_linear_3871_969)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28873 35.6063C8.21885 35.5173 8.22214 35.39 8.29754 35.3035C8.37294 35.217 8.4975 35.1953 8.5976 35.2511C8.91467 35.4124 9.27907 35.5371 9.75942 35.6304C10.553 35.7857 11.4899 35.6411 12.4375 34.9943C13.4024 34.3363 13.6758 33.2419 13.6758 33.2419C13.6758 33.2419 15.3163 35.1227 14.9269 36.0659C14.5654 36.9445 13.4768 37.512 12.1861 37.5925C11.1073 37.6603 9.57971 37.3769 8.28873 35.6063Z",
    fill: "url(#paint15_linear_3871_969)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16733 31.9446C6.11705 31.8412 6.14516 31.7178 6.23547 31.647C6.3262 31.5779 6.45373 31.5801 6.53999 31.654C6.80541 31.8597 7.12 32.0424 7.54413 32.2194C8.26739 32.5219 9.18521 32.5664 10.211 32.1348C11.2553 31.6958 11.7282 30.7065 11.7282 30.7065C11.7282 30.7065 12.9194 32.8174 12.3659 33.6401C11.8515 34.4066 10.7072 34.7354 9.466 34.5609C8.43489 34.4165 7.04907 33.8548 6.16733 31.9446Z",
    fill: "url(#paint16_linear_3871_969)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61202 27.8405C5.58228 27.7303 5.63462 27.6141 5.73633 27.5623C5.83805 27.5104 5.96236 27.5383 6.0336 27.6275C6.24107 27.8655 6.49712 28.0923 6.85033 28.3347C7.47445 28.7634 8.33332 28.9864 9.38813 28.7801C10.4619 28.5704 11.104 27.7274 11.104 27.7274C11.104 27.7274 11.814 29.9596 11.1286 30.629C10.4912 31.2531 9.34463 31.3387 8.20566 30.929C7.26607 30.5906 6.07542 29.7957 5.61202 27.8405Z",
    fill: "url(#paint17_linear_3871_969)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21658 23.8211C5.21058 23.7071 5.28389 23.6048 5.39372 23.5753C5.50355 23.5458 5.61866 23.5961 5.67147 23.6977C5.81798 23.9526 6.01021 24.211 6.28423 24.5003C6.78675 25.0306 7.55217 25.4141 8.58892 25.4319C9.64425 25.4503 10.4198 24.7841 10.4198 24.7841C10.4198 24.7841 10.6401 27.0338 9.85867 27.5275C9.1316 27.988 8.0326 27.8378 7.0405 27.2218C6.22731 26.7164 5.27063 25.7355 5.21658 23.8211Z",
    fill: "url(#paint18_linear_3871_969)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8412 20.0497C5.85541 19.9359 5.94687 19.8489 6.05993 19.8407C6.17255 19.8315 6.27689 19.9036 6.3087 20.0137C6.39722 20.2743 6.52521 20.5461 6.72089 20.8608C7.09131 21.4589 7.73756 21.9696 8.70993 22.188C9.69965 22.4106 10.5584 21.9329 10.5584 21.9329C10.5584 21.9329 10.3307 24.0984 9.49974 24.4122C8.72634 24.7053 7.72101 24.3498 6.90638 23.5756C6.24293 22.9447 5.53804 21.8438 5.8412 20.0497Z",
    fill: "url(#paint19_linear_3871_969)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29485 16.6184C7.3308 16.5119 7.43605 16.4453 7.54673 16.4591C7.65843 16.4726 7.74481 16.5625 7.75499 16.6752C7.79189 16.9281 7.8583 17.1994 7.97574 17.5198C8.20726 18.1549 8.71439 18.7618 9.58397 19.1578C10.469 19.5612 11.3669 19.2802 11.3669 19.2802C11.3669 19.2802 10.7339 21.2722 9.89378 21.4045C9.11171 21.5286 8.23777 20.9972 7.62378 20.1094C7.12694 19.3907 6.68281 18.2292 7.29485 16.6184Z",
    fill: "url(#paint20_linear_3871_969)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.412 5.11844C37.4512 5.11844 45.6032 13.2704 45.6032 23.3097C45.6032 33.349 37.4512 41.5009 27.412 41.5009C17.3727 41.5009 9.2207 33.349 9.2207 23.3097C9.2207 13.2704 17.3727 5.11844 27.412 5.11844ZM27.412 8.1018C19.019 8.1018 12.2041 14.9167 12.2041 23.3097C12.2041 31.7027 19.019 38.5176 27.412 38.5176C35.8049 38.5176 42.6198 31.7027 42.6198 23.3097C42.6198 14.9167 35.8049 8.1018 27.412 8.1018Z",
    fill: "url(#paint21_linear_3871_969)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3871_969",
    x1: 27.5969,
    y1: 38.4869,
    x2: 27.5969,
    y2: 46.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3871_969",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8467 8.48033) rotate(64.4736) scale(35.6612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3871_969",
    x1: 34.8303,
    y1: 15.3584,
    x2: 19.9402,
    y2: 31.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3871_969",
    x1: 36.5141,
    y1: 44.1083,
    x2: 35.891,
    y2: 38.8216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3871_969",
    x1: 40.467,
    y1: 41.843,
    x2: 38.8094,
    y2: 36.9854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3871_969",
    x1: 44.1489,
    y1: 39.0899,
    x2: 41.509,
    y2: 34.8914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3871_969",
    x1: 46.6358,
    y1: 35.5159,
    x2: 43.2795,
    y2: 32.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3871_969",
    x1: 48.7584,
    y1: 31.8388,
    x2: 44.8923,
    y2: 29.2239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3871_969",
    x1: 49.306,
    y1: 27.718,
    x2: 45.1343,
    y2: 26.0088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3871_969",
    x1: 49.6825,
    y1: 23.6853,
    x2: 45.4023,
    y2: 22.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3871_969",
    x1: 49.0314,
    y1: 19.9038,
    x2: 44.8534,
    y2: 20.0045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3871_969",
    x1: 47.5443,
    y1: 16.4722,
    x2: 43.643,
    y2: 17.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3871_969",
    x1: 18.4859,
    y1: 44.1083,
    x2: 19.109,
    y2: 38.8216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3871_969",
    x1: 14.533,
    y1: 41.843,
    x2: 16.1906,
    y2: 36.9854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3871_969",
    x1: 10.8511,
    y1: 39.0899,
    x2: 13.491,
    y2: 34.8914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3871_969",
    x1: 8.36418,
    y1: 35.5159,
    x2: 11.7205,
    y2: 32.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3871_969",
    x1: 6.24163,
    y1: 31.8388,
    x2: 10.1077,
    y2: 29.2239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3871_969",
    x1: 5.69403,
    y1: 27.718,
    x2: 9.86571,
    y2: 26.0088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3871_969",
    x1: 5.31749,
    y1: 23.6853,
    x2: 9.59767,
    y2: 22.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3871_969",
    x1: 5.96863,
    y1: 19.9038,
    x2: 10.1466,
    y2: 20.0045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3871_969",
    x1: 7.45566,
    y1: 16.4722,
    x2: 11.357,
    y2: 17.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3871_969",
    x1: 39.2613,
    y1: 10.1165,
    x2: 15.2579,
    y2: 36.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9F295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF8321"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/goldIcon.02a588250d582bf37eff03f62fddc6a2.svg";
export { ForwardRef as ReactComponent };